module.exports = __webpack_public_path__ + "cf9e182e1baf2798df2bcfd3c0ecb39d.png";